/**
 * CheckInBubble (spike) — a sample casual daily check-in bubble, showing how the tone shifts
 * by Link level and bond pairing (matched vs strictly platonic). Presentational only.
 */
import React from 'react';
import { Globe, HeartHandshake, Bot, Link2, type LucideIcon } from 'lucide-react';

const ICONS: Record<string, LucideIcon> = { Globe, HeartHandshake };

interface Props { agent: string; icon: string; linkLevel: number; toneLabel: string; text: string }

const CheckInBubble: React.FC<Props> = ({ agent, icon, linkLevel, toneLabel, text }) => {
  const Icon = ICONS[icon] || Bot;
  return (
    <div className="flex gap-3">
      <span className="flex items-center justify-center w-9 h-9 shrink-0 rounded-full bg-secondary-100 dark:bg-secondary-800 text-secondary-900 dark:text-white">
        <Icon className="w-4 h-4" />
      </span>
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-secondary-900 dark:text-white">{agent}</span>
          <span className="inline-flex items-center gap-1 text-[11px] text-secondary-400">
            <Link2 className="w-3 h-3" />{linkLevel}
          </span>
        </div>
        <div className="mt-1 inline-block rounded-2xl rounded-tl-sm bg-secondary-100 dark:bg-secondary-800 px-3.5 py-2 text-sm text-secondary-800 dark:text-secondary-100">
          {text}
        </div>
        <p className="mt-1 text-[11px] text-secondary-400">{toneLabel}</p>
      </div>
    </div>
  );
};

export default CheckInBubble;
